/**
 * @author WYX
 * @date 2019/12/26
 * @Description: 稿件标签指令模块
 */
angular.module('editPageTipsModule', []).directive('editPageTips', [
    '$q',
    '$timeout',
    'trsHttpService',
    'messagePublishService',
    function($q, $timeout, trsHttpService, messagePublishService) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/editPageTips/editPageTips.html',
            replace: true,
            transclude: true,
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.data = {
                        // 文章分类数组
                        articleClassArr: []
                    };
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    if ($scope.parentStatus.articleid){
                        messagePublishService.subscribe(
                            `${$scope.parentStatus.mediaName}ListInit`,
                            function() {
                                initLabel();
                                if ($scope.tipsUse.isShowType !== false){
                                    getClass();
                                }
                            },
                            $scope
                        );
                    } else {
                        initLabel();
                        if ($scope.tipsUse.isShowType !== false){
                            getClass();
                        }
                    }
                }

                /**
                 * [getClass description]获取文章分类
                 * @return  {[type]}  [return description]
                 */
                function getClass() {
                    $scope.loadingPromise = getArticleClass(7).then(function(data) {
                        data.unshift({
                            CLASSTEXT: '请选择文章分类',
                            ARTICLECLASSIFICATIONID: '',
                        });
                        $scope.data.articleClassArr = data;
                        if (!$scope.list.ARTICLECLASSIFICATION || $scope.list.ARTICLECLASSIFICATION === '0') {
                            $scope.parentData.articleClass = data[0];
                            return;
                        }
                        for (var i = 0, len = data.length; i < len; i++) {
                            if ($scope.list.ARTICLECLASSIFICATION == data[i].ARTICLECLASSIFICATIONID) {
                                $scope.parentData.articleClass = data[i];
                                break;
                            }
                        }
                    });
                }

                /**
                 * [initEditPath:function description]获取文章分类
                 * @param   {[type]}  docType    [docType description] 稿件类型
                 * @return  {[type]}  [return description]
                 */
                function getArticleClass(docType) {
                    var defer = $q.defer();
                    var params = {
                        serviceid: 'mlf_kuaibaoarticleclass',
                        methodname: 'query',
                        docType: docType,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        defer.resolve(data);
                    });
                    return defer.promise;
                }

                // 标签方法
                /**
                 * [initKeyWords description]初始化关键词
                 * @return {[type]} [description]
                 */
                function initLabel() {
                    if ($scope.list.LABEL) {
                        var LABEL = $scope.list.LABEL.split(',');
                        $scope.parentData.LABEL = [];
                        angular.forEach(LABEL, function(data, index, array) {
                            $scope.parentData.LABEL.push({
                                name: data,
                            });
                        });
                    } else {
                        $scope.parentData.LABEL = [];
                    }
                }
                $scope.checkTag = function(tag) {
                    var len = $scope.parentData.LABEL.length;
                    if (len == 5) {
                        $scope.isShowKeywordTips = true;
                        $scope.keywordsTips = '标签个数不能超过5个！';
                        return false;
                    } else {
                        $scope.keywordsTips = '';
                        $scope.isShowKeywordTips = false;
                    }
                    if (tag.name.indexOf(' ') > -1) {
                        var spaceArr = tag.name.split(' ');
                        $timeout(function() {
                            $scope.data.label.pop();
                            var containArr = [];
                            for (var j = 0; j < $scope.data.label.length; j++) {
                                containArr.push($scope.data.KEYWORDS[j].name);
                            }
                            for (var i = 0; i < spaceArr.length; i++) {
                                if (containArr.indexOf(spaceArr[i]) < 0 && spaceArr[i] != '') {
                                    $scope.data.label.push({ name: spaceArr[i] });
                                    containArr.push(spaceArr[i]);
                                }
                            }
                        });
                    }
                };
                $scope.leave = function() {
                    // $scope.isShowKeywordTips = false;
                };
                $scope.invalidTag = function(tag) {
                    var reg = /^[^<>\/;]*$/;
                    if (tag.name.length > 8) {
                        $scope.isShowKeywordTips = true;
                        $scope.keywordsTips = '单个标签长度不能超过8！';
                    }
                    if (!reg.test(tag.name)) {
                        $scope.isShowKeywordTips = true;
                        $scope.keywordsTips = '不能包含特殊字符！';
                    }
                };
            },
        };
    },
]);
